import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';
import chromeExtensionMixin from '../../mixins/_chrome_extension';
import updateStorecreatorData from '../../components/_update_storecreator_data';
import tasks from '../guide/_tasks';

const PAGES = [
    // ようこその画面
    'WELCOME',
    // chromeを利用中か確認画面
    'CHECK_CHROME',
    // chromeを利用中か確認画面
    'CONFIRM_CHROME',
    // ストアクリエイターPro権限確認の画面
    'CHECK_AUTHORITY',
    // chrome拡張機能のインストール画面
    'INSTALL_CHROME',
    // ポップアップブロック解除手順の画面
    // ブロックされてから案内に変更。コメントアウトで画面自体は残しておく。
    //    'POPUP_SETTING',
    // 初期設定サポートを始めるかの確認ページ
    'CONFIRM_NEXT_ACTION'
];

const view = '[data-view="welcome"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // 最初のページ
                page: PAGES[0],
                // ストアクリエイターのデータ取得完了フラグ
                finished_update_storecreator_data: false,
                // ストアクリエイターから取得データデータ一覧
                storecreator_data: {},
                // ページ移動可能フラグ(ダブルクリック防止用)
                can_move_page: true,
            };
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            commonMixin,
            chromeExtensionMixin,
            flashMessageMixin
        ],
        /**
         * 算出プロパティ
         */
        computed: {
            // ページ表示順番号(index)
            pageIndex () {
                return PAGES.indexOf(this.page);
            },
            // 最初のページか否か
            isFirstPage () {
                return (0 === this.pageIndex);
            },
            // ストクリの開店前stepが最初か
            isFirstOpeningStep () {
                if (typeof this.storecreator_data.opening_step !== 'undefined' && Number(this.storecreator_data.opening_step) === 1) {
                    return true;
                }
                return false;
            },
        },
        components: {
            // タスク表示コンポーネント
            'tasks': tasks,
            // 拡張機能テストモーダル
            'modal-update-storecreator-data': {
                template: '#modal_update_storecreator_data_template',
                props: {
                    // 取得完了フラグ
                    finished_update_storecreator_data: {
                        type: Boolean,
                        default: false,
                        require: true,
                    },
                    // ストクリから取得するデータ
                    storecreator_data: {
                        type: Object,
                        default: () => ({}),
                        require: true,
                    }
                },
                mixins: [
                    modalMixin,
                ],
                components: {
                    // ストアクリエイターからデータを取得するコンポーネント
                    'update-storecreator-data': updateStorecreatorData,
                },
                emits: [
                    'update:storecreator_data',
                    'update:finished_update_storecreator_data',
                ],
                methods: {
                    // -------------------------
                    // emit
                    // -------------------------

                    // 拡張機能から取得したデータをJS側で保持する
                    emitStorecreatorData: function (...data) {
                        let storecreatorData = this.storecreator_data;
                        const [value, key] = data;
                        storecreatorData[key] = value;
                        this.$emit('update:storecreator_data', storecreatorData);
                    },
                    // 拡張機能からデータ取得完了時
                    emitStorecreatorDataFinished: function () {
                        this.open();
                        this.$emit('update:finished_update_storecreator_data', true);
                    },
                }
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            // 拡張機能テストモーダルの開閉
            open: function () {
                this.$refs.modal_update_storecreator_data.open();
            },
            close: function () {
                this.$refs.modal_update_storecreator_data.close();
            },
            // welcome通過済みフラグを立てる
            complete: async function() {
                this.$_loading();
                let success = false;
                let message = this.exception_error_message;
                try {
                    const response = await axios.post('/welcome/complete', {
                        _method: 'POST'
                    });
                    if (response.data.status === 'OK') {
                        message = '';
                        success = true;
                    }
                } catch (e) {
                    message = this.getCatchMessage(e);
                }
                this.$_unloading();
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
                return success;
            },
            // 次(前)表示するページindexを取得
            async getPageKey(fluctuation) {
                const pageKey = PAGES[this.pageIndex + fluctuation];
                // Chromeを使っていたら次ページへ
                if (pageKey === 'CHECK_CHROME' && this.$_useChrome()) {
                    return await this.getPageKey(fluctuation + Math.sign(fluctuation));
                }
                // CONFIRM_NEXT_ACTIONページに進む前にwelcome通過済みフラグを立てる
                if (pageKey === 'CONFIRM_NEXT_ACTION') {
                    if (await this.complete()) {
                        this.close();
                    } else {
                        return PAGES[this.pageIndex];
                    }
                }
                return pageKey;
            },
            // 次画面へ
            async next () {
                this.can_move_page = false;
                this.page = await this.getPageKey(1);
                await this.$nextTick();
                this.can_move_page = true;
            },
            // 前画面へ
            async prev () {
                this.can_move_page = false;
                this.page = await this.getPageKey(-1);
                await this.$nextTick();
                this.can_move_page = true;
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
